import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { WindowDragStrip } from '../components/WindowDragStrip.tsx'

export interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <WindowDragStrip />
      <Outlet />
    </>
  ),
})
